<!-- <template>
  <div id="app">
    <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav>
    <router-view/>
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style> -->
<template>
  <div class="layout-container flex h-full min-h-screen grow flex-col" v-if="!loading">
    <!-- Banner de notificaciones -->
    <NotificationBanner 
      @notification-enabled="onNotificationEnabled"
      @notification-error="onNotificationError"
    />
    
    <Navbar v-if="!isAdminRoute" />

    <!-- <HeroSection />
    <Footer /> -->
    <router-view />
    <Footer />
    
    <!-- Comparison Bar -->
    <ComparisonBar />
    
    <!-- Toast para mostrar mensajes -->
    <div v-if="toastMessage" class="toast toast-top toast-center z-50">
      <div class="alert" :class="toastClass">
        <span>{{ toastMessage }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import HeroSection from './components/HeroSection.vue'
import Footer from './components/Footer.vue'
import NotificationBanner from './components/common/NotificationBanner.vue'
import ComparisonBar from './components/common/ComparisonBar.vue'
import { mapActions, mapGetters } from 'vuex'
import { onMessage, messaging } from './firebase-config';

export default {
  components: {
    Navbar,
    HeroSection,
    Footer,
    NotificationBanner,
    ComparisonBar
  },
  data() {
    return {
      loading: true,
      toastMessage: '',
      toastClass: ''
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    }),
    isAdminRoute() {
      return this.$route.path.startsWith('/admin')
    }
  },
  methods: {
    ...mapActions({
      loadUser: 'auth/loadUser',
      fetchCustomizations: 'FETCH_CUSTOMIZATIONS',
      loadComparisonFromStorage: 'comparison/loadComparisonFromStorage'
    }),
    
    onNotificationEnabled() {
      this.showToast('¡Notificaciones habilitadas correctamente!', 'alert-success');
    },
    
    onNotificationError(errorMessage) {
      this.showToast(`Error: ${errorMessage}`, 'alert-error');
    },
    
    showToast(message, className = 'alert-info') {
      this.toastMessage = message;
      this.toastClass = className;
      
      setTimeout(() => {
        this.toastMessage = '';
        this.toastClass = '';
      }, 5000);
    },
    
    showForegroundNotification(payload) {
      const title = payload.notification?.title || 'Nueva notificación';
      const body = payload.notification?.body || 'Tienes una nueva actualización';
      
      this.showToast(`${title}: ${body}`, 'alert-info');
    }
  },
  async mounted() {
    this.loading = true;
    await this.fetchCustomizations();

    if (this.isAuthenticated) {
      await this.loadUser()
    }

    // Configurar listener para mensajes en primer plano
    if (messaging) {
      onMessage(messaging, (payload) => {
        console.log('Notificación recibida en primer plano:', payload);
        this.showForegroundNotification(payload);
      });
    }
    
    // Cargar datos de comparación desde localStorage
    await this.loadComparisonFromStorage();
    
    // Setup toast listener for comparison actions
    window.addEventListener('show-toast', (event) => {
      this.showToast(event.detail.message, `alert-${event.detail.type}`);
    });
    
    this.loading = false;
  }
}
</script>
